module.exports = __webpack_public_path__ + "static/media/gameDev08.769241d4.jpg";